import React from "react";
import { Link } from "react-router-dom";
import { InfoShell, InfoSection } from "@/components/InfoShell";
import { Globe, LifeBuoy } from "lucide-react";
import { Seo } from "@/components/Seo";

// NOTE: No authoritative inbound support email / phone / address is configured in the
// application (only the outbound sender no-reply@mail.propconnectai.com exists). To avoid
// fabricating contact details, this page directs users to in-app channels + the website.
export default function Contact() {
  return (
    <InfoShell testid="contact-page" eyebrow="Contact" title="Contact Us">
      <Seo
        title="Contact PropertyConnect"
        description="Get in touch with the PropertyConnect team. Reach support at support@propconnectai.com or through the platform."
        canonical="/contact"
        robots="index,follow"
      />
      <InfoSection>
        <p>We'd love to hear from you. During the controlled alpha, the fastest way to reach the PropertyConnect
        team is through the platform itself.</p>
      </InfoSection>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="border border-border rounded-xl bg-card p-6" data-testid="contact-support">
          <div className="h-11 w-11 rounded-xl bg-[#0F2C59]/6 text-[#0F2C59] flex items-center justify-center"><LifeBuoy className="h-5 w-5" /></div>
          <h2 className="font-display text-lg font-semibold text-slate-900 mt-4">Email Support</h2>
          <p className="text-[15px] text-slate-600 leading-relaxed mt-1.5">Reach the PropertyConnect team directly at{" "}
            <a href="mailto:support@propconnectai.com" data-testid="contact-support-email" className="text-accent font-semibold hover:underline">support@propconnectai.com</a>. You can also review common questions on the <Link to="/help" className="text-accent font-medium">Help &amp; FAQs</Link> page, or send a message from within PropertyConnect once signed in.</p>
        </div>
        <div className="border border-border rounded-xl bg-card p-6" data-testid="contact-web">
          <div className="h-11 w-11 rounded-xl bg-[#0F2C59]/6 text-[#0F2C59] flex items-center justify-center"><Globe className="h-5 w-5" /></div>
          <h2 className="font-display text-lg font-semibold text-slate-900 mt-4">On the web</h2>
          <p className="text-[15px] text-slate-600 leading-relaxed mt-1.5">Learn more about the platform at <span className="font-medium text-slate-800">propconnectai.com</span>.</p>
        </div>
      </div>

      <InfoSection>
        <p className="text-sm text-slate-400">Official contact channels will be expanded as PropertyConnect moves
        beyond the controlled alpha.</p>
      </InfoSection>
    </InfoShell>
  );
}
